import { clsx } from 'clsx';
import React from 'react';
import type { FacilityList } from '../../../../../js/api/models/FacilityList';
import { getFacilityLocationDisplayValue } from '../../../utils/facility';

const CardHeading: React.FC<React.ComponentPropsWithoutRef<'p'>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <p
      {...props}
      className={clsx(
        className,
        'tw:!text-[16px] tw:font-semibold tw:text-zinc-900 tw:dark:text-zinc-100 tw:!mb-0'
      )}
    >
      {children}
    </p>
  );
};

export const FacilityCard: React.FC<{
  facility: FacilityList;
  facilityTypeMap: Record<string, string>;
  emrMap: Record<string, string>;
  isSelected?: boolean;
}> = ({ facility, facilityTypeMap, emrMap, isSelected = false }) => {
  const location = getFacilityLocationDisplayValue(facility);
  const facilityTypeLabel = facilityTypeMap[facility.facility_type] || facility.facility_type;
  const emrLabel = facility.emr ? emrMap[facility.emr] || facility.emr : null;

  return (
    <div
      className={clsx(
        'tw:h-full tw:bg-white tw:rounded-lg tw:shadow-sm tw:border tw:border-zinc-200 tw:hover:shadow-md tw:hover:bg-muted tw:transition-shadow tw:cursor-pointer tw:dark:bg-zinc-700 tw:dark:border-zinc-400 tw:dark:hover:bg-zinc-600',
        isSelected && 'tw:!bg-brand-green-0/10 tw:!shadow-md'
      )}
    >
      <div className="tw:p-3">
        <div className="tw:flex tw:justify-between tw:items-start tw:mb-2">
          <CardHeading className="tw:line-clamp-2">
            <i className="far fa-fw fa-lg fa-hospital tw:mr-1" />
            {facility.name}
          </CardHeading>
        </div>
        {location && (
          <div className="tw:flex tw:items-center tw:gap-2 tw:mb-1 tw:text-sm tw:text-zinc-600 tw:dark:text-zinc-400">
            <i className="far fa-fw fa-location-dot tw:text-zinc-400 tw:dark:text-zinc-500" />
            <span>{location}</span>
          </div>
        )}
        <div className="tw:flex tw:flex-wrap tw:gap-2 tw:mt-2">
          {facilityTypeLabel && (
            <span className="tw:inline-flex tw:items-center tw:px-2 tw:py-0.5 tw:rounded tw:text-xs tw:bg-zinc-100 tw:text-zinc-700 tw:dark:bg-zinc-600 tw:dark:text-zinc-200">
              {facilityTypeLabel}
            </span>
          )}
          {emrLabel && (
            <span className="tw:inline-flex tw:items-center tw:px-2 tw:py-0.5 tw:rounded tw:text-xs tw:bg-zinc-100 tw:text-zinc-700 tw:dark:bg-zinc-600 tw:dark:text-zinc-200">
              {emrLabel}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default FacilityCard;
